import React from "react";

function IconAppSwitcher() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, React.createElement("rect", {
    width: "20",
    height: "20",
    fill: "#F0F2F4",
    rx: "4"
  }), React.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "2",
    fill: "#FD5154"
  }), React.createElement("circle", {
    cx: "6",
    cy: "14",
    r: "2",
    fill: "#3A7ABE"
  }), React.createElement("circle", {
    cx: "14",
    cy: "6",
    r: "2",
    fill: "#0AA1DC"
  }), React.createElement("circle", {
    cx: "6",
    cy: "6",
    r: "2",
    fill: "#20B575"
  }));
}

export default IconAppSwitcher;